; (function ($) {
    // Strict Mode
    'use strict';

    const congrats = function congrats($scope, $) {
        const $this = $scope.find('.congrats-slider');
        const $id_str = $this.attr('id');
        const $id = '#' + $this.attr('id');
        const sliderType = $this.data('type');
        const autoplay = $this.data('autoplay');
        const loop = $this.data('loop');
        const blogSwiper = $($id);
        let congratsSlider;
        let options = {}
        if (autoplay) {

            options = {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 3000,
                },
                loop: (loop) ? loop : false,
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },
            }

        } else {
            options = {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: loop ? loop : false,
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },
            }
        }


        if ('undefined' === typeof Swiper) {

            console.log('undefined');
            const asyncSwiper = elementorFrontend.utils.swiper;
            new asyncSwiper(blogSwiper, options).then((newSwiperInstance) => {
                congratsSlider = newSwiperInstance;
            });
        } else {
            console.log('global');
            congratsSlider = new Swiper(blogSwiper, options);
        }

    };

    jQuery(window).on('elementor/frontend/init', function () {
        elementorFrontend.hooks.addAction('frontend/element_ready/pf-congrats-slider.default', congrats);
    });



})(jQuery);